import React from 'react';
import { v4 as uuid4 } from 'uuid';
import { Switch, Route, Redirect } from 'react-router-dom';
import Lead from '@/modules/leads/components/Lead/Lead';
import Leads from '@/modules/leads/components/Leads/Leads';
import Offer from '@/modules/offers/components/Offer/Offer';
import Types from '@/modules/types/components/Types';
import Users from '@/modules/users/components/Users/Users';
import Notes from '@/modules/notes/components/Notes';
import Offers from '@/modules/offers/components/Offers/Offers';
import Admins from '@/modules/users/components/Admins/Admins';
import Prices from '@/modules/prices/components/Prices';
import Clients from "@/modules/users/components/Clients/Clients";
import Profile from '@/modules/profile/components/Profile';
import Journal from '@/modules/journal/components/Journal';
import Statuses from '@/modules/statuses/components/Statuses';
import Settings from '@/modules/settings/components/Settings';
import NotFound from '@/modules/common/components/NotFound';
import Landings from '@/modules/landings/components/Landings';
import PostBacks from '@/modules/pb/components/PostBacks';
import TextFiles from '@/modules/files/components/TextFiles/TextFiles';
import Affiliates from '@/modules/users/components/Affiliates/Affiliates';
import AutoStatuses from '@/modules/auto_statuses/components/AutoStatuses';
import ErrorBoundary from '@/modules/common/components/ErrorBoundary';
import ReportSummary from '@/modules/reports/components/ReportSummary/ReportSummary';
import ReportConversion from '@/modules/reports/components/ReportConversion/ReportConversion';
import LeadsStatusesFetch from '@/modules/leads_statuses/components/LeadsStatusesFetch/LeadsStatusesFetch';
import LeadsStatusesDatabase from '@/modules/leads_statuses/components/LeadsStatusesDatabase/LeadsStatusesDatabase';

const Component = () => {
    return (
        <Switch>
            <Route exact={true} path="/">
                <Redirect to="/profile/"/>
            </Route>
            <Route exact={true} path="/profile/" render={(props) => (
                <ErrorBoundary {...props}><Profile {...props} key={uuid4()}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/leads_statuses/db/" render={(props) => (
                <ErrorBoundary {...props}><LeadsStatusesDatabase {...props} key={uuid4()}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/leads_statuses/fetch/" render={(props) => (
                <ErrorBoundary {...props}><LeadsStatusesFetch {...props} key={uuid4()}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/reports/summary/:offerName?/:affiliateName?/" render={(props) => (
                <ErrorBoundary {...props}><ReportSummary {...props} key={uuid4()}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/reports/conversion/:offerName?/:affiliateName?/" render={(props) => (
                <ErrorBoundary {...props}><ReportConversion {...props} key={uuid4()}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/leads/" render={(props) => (
                <ErrorBoundary {...props}><Leads {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/leads/:id/" render={(props) => (
                <ErrorBoundary {...props}><Lead {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/offers/" render={(props) => (
                <ErrorBoundary {...props}><Offers {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/offers/:name/" render={(props) => (
                <ErrorBoundary {...props}><Offer {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/offers/:offerName/types/" render={(props) => (
                <ErrorBoundary {...props}><Types {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/offers/:offerName/statuses/" render={(props) => (
                <ErrorBoundary {...props}><Statuses {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/offers/:offerName/auto-statuses/" render={(props) => (
                <ErrorBoundary {...props}><AutoStatuses {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/offers/:offerName/landings/" render={(props) => (
                <ErrorBoundary {...props}><Landings {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/users/" render={(props) => (
                <ErrorBoundary {...props}><Users {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/users/admins/" render={(props) => (
                <ErrorBoundary {...props}><Admins {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/users/affiliates/" render={(props) => (
                <ErrorBoundary {...props}><Affiliates {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/users/clients/" render={(props) => (
                <ErrorBoundary {...props}><Clients {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/users/:username/" render={(props) => (
                <ErrorBoundary {...props}><Profile {...props} key={uuid4()}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/users/:username/postbacks/" render={(props) => (
                <ErrorBoundary {...props}><PostBacks {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/users/:username/prices/" render={(props) => (
                <ErrorBoundary {...props}><Prices {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/files/text/" render={(props) => (
                <ErrorBoundary {...props}><TextFiles {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/notes/:offerName?/" render={(props) => (
                <ErrorBoundary {...props}><Notes {...props} key={uuid4()}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/journal/" render={(props) => (
                <ErrorBoundary {...props}><Journal {...props}/></ErrorBoundary>
            )}/>
            <Route exact={true} path="/settings/" render={(props) => (
                <ErrorBoundary {...props}><Settings {...props}/></ErrorBoundary>
            )}/>
            <Route component={NotFound}/>
        </Switch>
    );
};

export default Component;
